<template>
    <a-layout class="topup">
        <a-layout-header>
            <page-nav></page-nav>
        </a-layout-header>
        <a-layout-content>
            <div class="content">
                <div class="header">
                    <p class="title">{{ $t('withdraw.withdraw') }}</p>
                    <div class="label">
                                                  <p>{{ $t('withdraw.withdraw_currency') }}</p>
                        <a-trigger position="bottom" :popup-translate="[0, -40]" :render-to-body="false">
                            <div class="inputBox">
                                <span class="span">{{ coinVal }}</span>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="list">
                                    <coin-list :display="true"></coin-list>
                                </div>
                            </template>
                        </a-trigger>
                    </div>
                    <div class="label">
                                                  <p>{{ $t('withdraw.withdraw_network') }}</p>
                        <a-trigger position="bottom" :render-to-body="false">
                            <div class="inputBox">
                                <span class="span">{{ coinVal }}</span>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="list">
                                    <div class="cell">
                                        <span class="color-black">Ethereum(ERC20)</span>
                                    </div>
                                </div>
                            </template>
                        </a-trigger>
                    </div>
                    <div class="label">
                                                  <p>{{ $t('withdraw.withdraw_address') }}</p>
                                                  <a-input class="input-box" :placeholder="$t('withdraw.enter_address')">
                            <template #suffix>
                                <span class="color-primary cursor" @click="visible = true">{{ $t('withdraw.address_management') }}</span>
                            </template>
                        </a-input>
                    </div>
                    <div class="label">
                                                  <p>{{ $t('withdraw.withdraw_amount') }}</p>
                                                  <a-input class="input-box" :placeholder="$t('withdraw.enter_amount')">
                            <template #suffix>
                                                                  <span class="color-primary cursor">{{ $t('withdraw.withdraw_all') }}</span>
                            </template>
                        </a-input>
                        <p class="num_tip">{{ $t('assets.available') }} <span>--BCH</span></p>
                        <p class="num_tip">{{ $t('withdraw.fee') }} <span>0.001 BCH</span></p>
                    </div>
                                                <a-button class="button">{{ $t('withdraw.submit_withdraw') }}</a-button>
                    <div class="label">
                        <div class="tips">
                            <p>
                                <span>{{ $t('withdraw.min_withdraw') }}</span>
                                <span>0.7 AAVE</span>
                            </p>
                            <p>
                                <span>{{ $t('withdraw.max_withdraw') }}</span>
                                <span>10,000 AAVE</span>
                            </p>
                            <p>
                                <span>{{ $t('withdraw.daily_limit') }}</span>
                                <span>10,000 AAVE</span>
                            </p>
                            <p>
                                <span>{{ $t('withdraw.hourly_limit') }}</span>
                                <span>21,905.805 AAVE</span>
                            </p>
                        </div>
                        <div class="tips" type="tip">
                            <p>
                                <span>{{ $t('withdraw.withdraw_reminder') }}</span>
                                {{ $t('withdraw.security_policy_reminder') }}<br>
                                {{ $t('withdraw.relogin_wait_reminder') }}<br>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="btm">
                    <p class="title">{{ $t('withdraw.recent_withdrawals') }}</p>
                    <div class="warp">
                        <a-scrollbar class="topup-list">
                            <div class="cell">
                                <span>{{ $t('common.time') }}</span>
                                <span>{{ $t('common.currency') }}</span>
                                <span>{{ $t('withdraw.withdraw_network') }}</span>
                                <span>{{ $t('withdraw.withdraw_amount') }}</span>
                                <span>{{ $t('withdraw.withdraw_address') }}</span>
                                <span>{{ $t('deposit.transaction_hash') }}</span>
                                <span>{{ $t('deposit.confirmations') }}</span>
                                <span>{{ $t('common.status') }}</span>
                                <span>{{ $t('common.operation') }}</span>
                            </div>
                            <div class="cell" v-for="i in 30">
                                <span>2023-09-14 14:50:01</span>
                                <span>
                                <img src="@/assets/images/coin/usdt.png" alt="">
                                USDT
                            </span>
                                <span>Tron(TRC20)</span>
                                <span>21.999925</span>
                                <span class="up_line">
                                <b>TJTE6HJZ...pH54r5Pj</b>
                                <icon-copy/>
                            </span>
                                <span class="up_line">
                                <b>d6ca082c...1e82c04a</b>
                                 <icon-copy/>
                            </span>
                                <span>6/6</span>
                                <span class="color-green">{{ $t('assets.deposit_success') }}</span>
                                <span>{{ $t('personal.view_details') }}</span>
                            </div>
                        </a-scrollbar>
                    </div>
                </div>
            </div>
            <a-modal :visible="visible" :ok-text="$t('common.manage')" :closable="false" @cancel="visible = false" :hide-title="true">
                <div class="model">
                    <p>{{ $t('withdraw.address_management') }}</p>
                    <a-scrollbar class="add_scroll">
                        <div class="cell">
                            <span>adasdasadasdasdasd9879797789779</span>
                        </div>
                    </a-scrollbar>
                </div>
            </a-modal>
        </a-layout-content>
        <a-layout-footer>
            <Footer></Footer>
        </a-layout-footer>
    </a-layout>
</template>

<style lang="scss" scoped>
@import "withdraw";
</style>
<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import CoinList from "@/components/coinList/coinList.vue";

export default {
    components: {
        PageNav,
        Footer,
        CoinList
    },
    data() {
        return {
            coinVal: this.$t('withdraw.select_currency'),
            visible: false
        }
    }
}
</script>
